import React, { memo, useCallback, useMemo, useRef, useState } from "react";
import { cn } from "utils";
import { Countdown } from "../../CountDown";

import { BillingCycle } from "./constants";
import { BillingCycleType } from "./types";
import BillingToggle from "./BillingToggle";
import CardList from "./SubscriptionCard/CardList";
import Footer from "./Footer";
import SubscriptionHeader from "./SubscriptionHeader";
import { useMemberStripeCheckout } from "./useMemberStripeCheckout";
import { I18nUtil } from "@utils/i18n";
import { MemberPlanInfo } from "@/src/hooks";
import Translations from "@translate/components/Member/Subscription/index";
import { useMemberPlansHandle } from "@/src/hooks/useMemberPlansHandle";
import { usePlusCountDown } from "@/src/hooks/usePlusCountDown";
import { Member, MemberProduct } from "@/src/features/api/memberApi";

const I18n = I18nUtil.createScoped(Translations);

interface SubscriptionType {
  handleChange?: (key: string) => void;
  className?: string;
  isTrial?: boolean;
  isLoading?: boolean;
  trialList?: any;
  data?: MemberProduct[];
  userPlanInfo?: Member & MemberPlanInfo;
  onAppPurchaseSuccess?: (productId: string) => void;
}

const Subscription = ({
  className,
  isTrial,
  isLoading,
  trialList,
  data,
  userPlanInfo,
  // onAppPurchaseSuccess,
}: SubscriptionType) => {
  const subscriptionContainerRef = useRef<HTMLDivElement>(null);
  const [billingCycle, setBillingCycle] = useState<BillingCycleType>(
    BillingCycle.YEAR,
  );

  const { subscriptionPlans, hasActiveDiscount } = useMemberPlansHandle({
    data: data ?? [],
    billingCycle,
  });
  const { isPaying, handleStripeClick } = useMemberStripeCheckout({
    data,
  });

  // 计费周期切换处理
  const handleBillingCycleChange = useCallback((cycle: BillingCycleType) => {
    setBillingCycle(cycle);
  }, []);

  // 活动折扣已下线，倒计时始终为 0
  const countdownMilliseconds = useMemo(() => 0, []);

  const { time, isRunning } = usePlusCountDown({
    milliseconds: countdownMilliseconds,
  });
  return (
    <div
      className={cn(
        "pt-3 md:px-4 flex flex-col overflow-auto no-scrollbar flex-1 max-h-[calc(100vh-68px)] z-4",
        className,
      )}
      id="member-subscription-container"
      ref={subscriptionContainerRef}
    >
      {isRunning && (
        <div
          className="md:hidden px-4 py-2 h-[58px] w-full flex items-center justify-between"
          style={{
            background:
              "url(/assets/images/activity/chirstmas-icon.png) no-repeat left center #082C1B",
            backgroundSize: "58px 100%",
          }}
        >
          <div className="text-content_primary title_l ml-3">
            {I18n.t("Christmas Offer")}
          </div>
          <div className="flex items-center">
            <Countdown
              countdown={time}
              labelMap={{}}
              className="w-8 h-8 rounded-2"
              containerClassName="w-4"
              textClassName="title_m w-4"
              countDownClassName="w-8 h-8"
            />
          </div>
        </div>
      )}
      <SubscriptionHeader
        title={I18n.t("Your Personalized AI for Markets")}
        desc={I18n.t(
          "Choose how advanced Edgen gets, from essential signals to a fully tailored investment assistant built for you.",
        )}
      />
      <div className="flex flex-row justify-center items-center md:mt-5 mt-4 mb-8 max-md:mb-0">
        <BillingToggle
          initialBillingCycle={billingCycle}
          onChange={handleBillingCycleChange}
        />
      </div>
      <div className="hidden md:flex flex-col gap-16 justify-center">
        <CardList
          plans={subscriptionPlans}
          billingCycle={billingCycle}
          isLoading={isLoading || isPaying}
          userPlanInfo={userPlanInfo as any}
          isTrial={!!isTrial}
          onStripeClick={handleStripeClick}
          trialList={trialList as any}
          hasActiveDiscount={hasActiveDiscount}
          isDiscount={isRunning}
          time={time}
        />
        {/* <FeatureComparisonTable
          plans={subscriptionPlans as any}
          billingCycle={billingCycle}
        /> */}
        {/* <AIFeaturesNavigator
          domElement={subscriptionContainerRef.current || undefined}
        /> */}
      </div>
      {/* <div className="block md:hidden px-4">
        <CardListH5
          plans={subscriptionPlans}
          billingCycle={billingCycle}
          isLoading={isLoading || isPaying}
          userPlanInfo={userPlanInfo as any}
          isTrial={!!isTrial}
          onStripeClick={handleStripeClick}
          trialList={trialList as any}
          isDiscount={isRunning}
          onAppPurchaseSuccess={onAppPurchaseSuccess}
        />
      </div> */}
      <Footer
        text={I18n.t("Edgen for teams or business?")}
        className="md:flex hidden pt-16"
      />
      {/* <PendingTipModal
        open={openPendingTipModal}
        onClose={() => {
          setOpenPendingTipModal(false);
        }}
        onReorder={() => cancelPaypal(pendingOrder.id)}
        onPay={() => {
          window.location.href = pendingOrder.links.find(
            (item: { rel: string }) => item.rel === "approve",
          ).href;
          setTimeout(() => {
            setOpenPendingTipModal(false);
          }, 1000);
        }}
        process={isProcess as "isPending" | "isSubscribe"}
      /> */}
    </div>
  );
};

export default memo(Subscription);
